import React from 'react'
import useChartColors from './useChartColors'

// Rótulo de barra num <text> simples (o Label do recharts quebra a linha quando o texto é mais largo que a barra).
// placement 'top': em cima da barra; 'right': na ponta da barra horizontal
export const BarLabel = ({ x, y, width, height, value, formatter, placement = 'top', fontSize = 11, fontWeight = 400 }) => {
  const { chart } = useChartColors()
  if ((value === null) || (value === undefined) || (value === '')) return null
  const text = formatter ? formatter(value) : value
  if (placement === 'right')
    return <text x={x + width + 6} y={y + (height / 2)} dy={4} fill={chart.ink} fontSize={fontSize} fontWeight={fontWeight}>{text}</text>
  return <text x={x + (width / 2)} y={y - 5} textAnchor='middle' fill={chart.ink} fontSize={fontSize} fontWeight={fontWeight}>{text}</text>
}

// Caixa do tooltip: título, valores em destaque com um traço da cor da série, e notas
export const TooltipBox = ({ title, rows = [], notes = [] }) => (
  <div className='dashboard-tooltip'>
    {title ? <div className='dashboard-tooltip-title'>{title}</div> : ''}
    {rows.map((row, index) => (
      <div className='dashboard-tooltip-row' key={index}>
        {row.color ? <i className={`dashboard-key ${row.dashed ? 'dashboard-key-dashed' : ''}`} style={{ '--dashboard-key': row.color }} /> : ''}
        <b>{row.value}</b>
        <span>{row.label}</span>
      </div>
    ))}
    {notes.filter(Boolean).map((note, index) => <div className='dashboard-tooltip-note' key={`note-${index}`}>{note}</div>)}
  </div>
)

// Contrato do recharts ({ active, payload, label }), como o CustomTooltip da home antiga.
// render(linha do gráfico, cores do tema) -> { title, rows, notes }. O React escapa o texto (títulos digitados pelo usuário)
const ChartTooltip = ({ active, payload, render }) => {
  const { chart } = useChartColors()
  if (!active || !payload?.length || !render) return null
  const content = render(payload[0].payload, chart)
  return content ? <TooltipBox {...content} /> : null
}

export default ChartTooltip
